import { FC } from "react";
import TransformationSvg from "../../public/icons/Trafo@2x.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const TransformationIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><TransformationSvg/></span>;
